import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

const SuccessModal = ({
  isOpen,
  close,
  onConfirm,
}: {
  isOpen: boolean;
  close: () => void;
  onConfirm?: () => void;
}) => {
  const onCancel = () => {
    close();
  };
  return (
    <Modal
      isVisible={isOpen}
      close={close}
      className="!max-h-full !w-[836px] justify-between sm:!max-h-[90vh]"
      scrollableClassName="min-h-full"
      enableScrolling
    >
      <div className="flex flex-col gap-2 rounded-t-lg bg-background-base-surface-3 px-8 py-6 font-bold leading-9">
        <h1 className="text-xl text-content-base-default lg:text-2xl">
          Service consolidation is underway!
        </h1>
        <h1 className="text-base text-content-base-subdued">
          Do you also want to generate a new Letter of authorization?{' '}
        </h1>
      </div>
      <div className="flex h-full w-full items-start gap-5 p-8">
        <GraniteButton
          size="large"
          onClick={onCancel}
          variant="secondary"
          type="button"
        >
          Back
        </GraniteButton>
        <GraniteButton size="large" variant="primary" onClick={onConfirm}>
          Add a Letter of authorization
        </GraniteButton>
      </div>
    </Modal>
  );
};

export default SuccessModal;
